import { User } from '@repo/domain/user';
import env from '@repo/env';
import Cookies from 'js-cookie';

import {
  ACCEPTED_TERMS_ACTION_KEY,
  COOKIE_LICENSING_MODAL_DISMISSED,
} from '../../global/constants';

const SHOW_MODAL_AGAIN_AFTER_DAYS = 7;

export const setDismissedCookie = (value: string): void => {
  Cookies.set(COOKIE_LICENSING_MODAL_DISMISSED, value, {
    expires: SHOW_MODAL_AGAIN_AFTER_DAYS,
    sameSite: 'lax',
    domain: env.cookieDomain,
    secure: true,
  });
};

export const getDismissedCookie = (): string | undefined => {
  return Cookies.get(COOKIE_LICENSING_MODAL_DISMISSED);
};

const NEW_TERMS_STARTED_AT = Date.UTC(2023, 4, 4);

const hasAutomaticallyAcceptedNewTerms = (user: User): boolean => {
  const createdAt = new Date(user.createdAt);

  return createdAt.getTime() > NEW_TERMS_STARTED_AT;
};

export const hasAcceptedNewTerms = (
  user: User,
  actions: ReadonlyArray<string>
): boolean => {
  return (
    hasAutomaticallyAcceptedNewTerms(user) ||
    actions.includes(ACCEPTED_TERMS_ACTION_KEY)
  );
};
